import { createContext } from 'react';
import initialCommercialAgentState from './initialCommercialAgentState';

const CommercialAgentContext = createContext(initialCommercialAgentState);

export default CommercialAgentContext;
